<template>
    <div id="modal-importGuests" class="modal">
        <button data-iziModal-close class="icon-close">
            <svg><use xlink:href="#i_close"></use></svg>
            <span class="sr-only">{{ $t('close') }}</span>
        </button>
        <div>
            <h2>{{ $t('importGuests') }}</h2>
            <form class="addGuestForm" method="post" onsubmit="return window.importGuests()">
                <input type="hidden" v-bind:value="event" name="event" data-id="eventID">
                <div class="row">
                    <div class="col-xs-12">
                        <FileUpload :modal="true" :extensions="['.xls','.xlsx']" v-on:uploaded="setFile" :label="'excel_file'" :placeHolder="'selectFile'" :required="true"></FileUpload>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 text-center" style="padding-top: 20px">
                        <a href="https://app.seatup.co.il/files/דוגמא לקובץ ייבוא אורחים.xlsx" target="_blank">{{ $t('importFileExample') }}</a><!-- | <a href="https://app.seatup.co.il/files/דוגמא לקובץ ייבוא אורחים לכנס.xlsx" target="_blank">{{ $t('importFileExampleConference') }}</a>-->
                    </div>
                </div>
                <div class="clearfix"></div>

            </form>

            <div class="modalLoader" style="display: none;">
                <rotate-loader style="opacity: .6" :color="'#132C43'"></rotate-loader>
            </div>
        </div>
    </div>
</template>

<script>
    import RotateLoader from 'vue-spinner/src/RotateLoader.vue'
    import FileUpload from '../Common/FileUpload'
    export default {
        name: "GuestsImportModal",
        components:{
            FileUpload,
            RotateLoader
        },
        props:['event'],
        data(){
            return{
                fileID:0,
                showLoader:false
            }
        },
        mounted(){
            let _this = this;
            window.importGuests = function(){
                $(".modalLoader").show();
                $('.addGuestForm').find('input,select').each(function(){
                    _this[$(this).data('id')] = $(this).val();
                });
                _this.save();
                return false;
            }
        },
        methods:{
            save(){
                this.$store.dispatch('importGuests',{fileID:this.fileID,eventID:$('[data-id="eventID"]').val()})
                                        .then(gData =>{
                                            //success
                                            this.$swal({
                                                confirmButtonText:this.$t('okButton'),
                                                type:'success',
                                                title:this.$t('importSuccessTitle'),
                                                text:this.$t('importSuccessText',{added:gData.added,failed:gData.failed}),
                                                timer:2000
                                            }).catch(this.$swal.noop);
                                            $(".modalLoader").hide();
                                            this.$emit('imported',gData)
                                            /*setTimeout(function(){ location.reload(); },1500)*/
                                        })
                                        .catch(err => {
                                            //err
                                            this.$swal({
                                                confirmButtonText:this.$t('okButton'),
                                                type:'error',
                                                title:this.$t('saveFailed'),
                                                timer:3000
                                            }).catch(this.$swal.noop);
                                            $(".modalLoader").hide();
                                        })
            },
            setFile(_){
                this.$data.fileID = _;
                this.save()
            },
        }
    }
</script>
